import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';
import { POINT_CONVERSION_COMPRESSED } from 'constants';
import directDebitForm from './common-form';

ReactModal.setAppElement('body');

export default directDebitForm({

    renderFlowProcess() {
        return <img width="600px" src="/static/directdebit-flow.png" alt="" />;
    },
    renderDocumentFields(){
        const { country, errors, fields } = this.props;
        
        return (
            <div className={`input ${errors['cuit'] ? 'invalid' : ''}`}>
                <label>CUIL/CUIT</label>
                <input name="cuit" value={fields.cuit} type="text" onChange={e => this.handleChange(e)} />
        
                {errors['cuit'] && <div className="error-tooltip">{errors['cuit']}</div>}
            </div>
        )
    },
    renderBankFields(){
        const { errors, fields } = this.props;
        return (
            <div className={`input ${errors['cbu'] ? 'invalid' : ''}`}>
                <ReactTooltip id="cbu" place="top" type="dark" effect="solid">
                    <span>Sin espacios ni guiones</span>
                </ReactTooltip>
                <label>
                    CBU (Clave Bancaria Uniforme) <a className="info" data-tip data-for="cbu" />
                </label>
                <input name="cbu" value={fields.cbu} onChange={e => this.handleChange(e)} type="text" />
                {errors['cbu'] && <div className="error-tooltip">{errors['cbu']}</div>}
            </div>
        );
    },
    renderAmountTitle() {
        return <label>Monto (pesos argentinos)</label>;
    },

    renderAttentionMessage() {
        return ([
            <p key="1">
                <i className="icon fa fa-exclamation-triangle" />
                Importante
            </p>,
            <p key="2">
                Si usted envía el formulario de débito directo luego de las once de la mañana, su cuenta
                bancaria será debitada al cuarto día hábil bancario y Booking será notificado al sexto día hábil
                bancario.
            </p>,
            <p key="3">
                Si usted envía el formulario de debito directo antes de las once de la mañana su cuenta bancaria
                será debitada en el tercer día hábil bancario y Booking será notificado al quinto día hábil
                bancario.
            </p>,
            <p key="4">
                Luego de enviado el formulario se le enviará un mail con la confirmación del envío y un link
                para chequear el estado del pago en cualquier momento.
            </p>]);
    }
});
